<template>
  <div class="el-form-item item">
    <!-- 搜索项 -->
    <el-select v-model="curSearchKey" placeholder="请选择" @change="onKeyChange" filterable>
      <el-option v-for="(n, i) in options" :key="n.label + i" :label="n.label" :value="n.keyName">
      </el-option>
    </el-select>
    <!-- 日期/时间控件 -->
    <el-date-picker class="val" v-model="curSearchValue" :type="type" :placeholder="'选择日期'" range-separator="至"
      start-placeholder="开始日期" end-placeholder="结束日期" @change="onValueChange">
    </el-date-picker>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    options: Array,
    type: String,
  },
  data() {
    return {
      curSearchKey: undefined,
      curSearchValue: undefined,
    };
  },
  watch: {
    options: {
      deep: true,
      handler(newVal) {
        console.log(newVal, this.options)
        if (newVal && newVal[0]) {
          this.curSearchKey = newVal[0].keyName
        }
      },
    },
    curSearchKey: {
      deep: true,
      handler(newVal, oldVal) {
        // console.log(newVal, oldVal)
        this.$emit("onChange", {
          key: oldVal,
          value: undefined,
        });
      },
    }
  },
  computed: {
    ...mapState([
      'user',
      'store',
    ]),
  },
  methods: {
    onKeyChange(v) {
      // console.log(v, typeof v);
      this.curSearchKey = v
      this.curSearchValue = undefined
    },
    onValueChange(v) {
      // console.log(this.curSearchKey, v, typeof v);
      if (!v) {
        this.$emit("onChange", {
          key: this.curSearchKey,
          value: v,
        });
        return
      } else if (!v.length) {
        const y = v.getFullYear()
        let m = v.getMonth() + 1
        m > 9 ? null : m = '0' + m
        let d = v.getDate()
        d > 9 ? null : d = '0' + d
        let s = ''
        switch (this.type) {
          case 'year':
            s = `${y}`;
            break;
          case 'month':
            s = `${y}-${m}`;
            break;
          default:
            s = `${y}-${m}-${d}`;
            break;
        }
        // console.log(this.keyName, s);
        this.$emit("onChange", {
          key: this.curSearchKey,
          value: s,
        });
      } else {
        const [val1, val2] = v
        const o1 = this.getDateStrObj(val1)
        const o2 = this.getDateStrObj(val2)
        // console.log(o1, o2)
        this.$emit("onChange", {
          key: this.curSearchKey,
          value: [
            `${o1.y}-${o1.m}-${o1.d}`,
            `${o2.y}-${o2.m}-${o2.d}`,
          ],
        });
      }
    },
    setNormalKey() {
      if (this.options && this.options[0]) {
        this.curSearchKey = this.options[0].keyName
      }
    },
    reset() {
      this.setNormalKey()
      this.curSearchValue = undefined
      this.$forceUpdate()
    },
  },
  mounted() {
    // 首先设置默认值
    this.setNormalKey()
    // 获取存储的搜索参数
    // console.log('store', { ...this.store })
    const path = this.$route.path
    if (this.store && this.store['formInline' + path]) {
      const formInline = this.store['formInline' + path]
      this.$forceUpdate()
      // console.log('formInline', { ...formInline })
      // console.log('options', this.options)
      this.options.map(v => {
        const key = v.keyName
        if (Object.hasOwnProperty.call(formInline, key) && formInline[key]) {
          this.curSearchKey = key
          this.curSearchValue = formInline[key]
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
.el-form-item {
  margin-right: 20px;

  /deep/ .el-select {

    .el-input {
      width: 110px;

      .el-input__inner {
        border-right-width: 0;
        border-radius: 4px 0 0 4px;

        &:focus {
          border-right-width: 1px;
        }
      }
    }
  }

  /deep/ .el-date-editor {
    .el-input__inner {
      border-radius: 0 4px 4px 0;
    }

    &.el-range-editor {
      border-radius: 0 4px 4px 0;
      width: 250px;
    }

    .el-range-separator {
      width: 20px;
    }
  }

  // >.val.el-range-editor {
  //   border-radius: 0 4px 4px 0;
  //   width: 250px;
  // }

}
</style>
